import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import {
  premiumUpsellButtonStyle,
  premiumUpsellCardContainerStyle,
  premiumUpsellHeartContainerStyle,
  premiumUpsellTextStyle
} from '@/components/Likes/LikeCard/styles.ts';
import { likeContainerStyle } from '@/components/Likes/styles.ts';
import UIConfig from '@/UIConfig.ts';
import Modal from '@/animations/Modal.tsx';
import PaywallPopup from '@/components/Popup/PaywallPopup/PaywallPopup.tsx';
import { PaywallTypes, ProductInvoicePlacements } from '@/enums/apiEnums.ts';
import PriorityLikesShape from '@/components/common/svg/shapes/paywall/PriorityLikesShape.tsx';

const PremiumUpsaleLikeCard = () => {
  const { t } = useTranslation();

  const [payWallOpen, setPayWallOpen] = useState<boolean>(false);
  const closePayWall = () => setPayWallOpen(false);
  const openPayWall = () => setPayWallOpen(true);

  return (
    <>
      <motion.div
        layout
        transition={{ type: 'spring', damping: 30, stiffness: 300 }}
        style={{ ...likeContainerStyle, border: '1px solid #000' }}
      >
        <div style={premiumUpsellCardContainerStyle} onClick={openPayWall}>
          <div
            style={{
              ...premiumUpsellHeartContainerStyle,
              backgroundImage: UIConfig.Colors.GradientPremium
            }}
          >
            <PriorityLikesShape width={26} height={26} fillColor="#fff" />
          </div>
          <div style={premiumUpsellTextStyle}>
            {t('custom_premium_your_likes_card.title')}
          </div>
          <button style={premiumUpsellButtonStyle} onClick={openPayWall}>
            {t('custom_premium_your_likes_card.button')}
          </button>
        </div>
      </motion.div>
      <Modal
        fullScreen
        scrollable
        open={payWallOpen}
        handleClose={closePayWall}
      >
        <PaywallPopup
          handleClose={closePayWall}
          type={PaywallTypes.TYPE_SUBSCRIPTION}
          placement={ProductInvoicePlacements.YOUR_LIKES_PAGE_BOOST_LIKES_CARD}
          prevHeaderTemplate="light"
        />
      </Modal>
    </>
  );
};

export default PremiumUpsaleLikeCard;
